import { Component,OnInit,OnDestroy,AfterViewInit,ViewChild,ElementRef,Input,Output,EventEmitter } from '@angular/core';
import { Router,ActivatedRoute,ParamMap,NavigationExtras } from "@angular/router";
import { takeWhile } from "rxjs/operators";
import addDays from 'date-fns/addDays';
import { format,parse,differenceInDays } from 'date-fns';
// import * as xlsx from 'xlsx';
import { Workbook,Worksheet,Alignment,Borders,Fill } from 'exceljs';
import * as iconv from 'iconv-lite';
import * as FileSaver from 'file-saver';

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiDtgReportCarService
    ,FvmsApiDtgCarService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {
    FilterDist
    ,FilterSecToTime
    ,FilterDateTime
    ,FilterDateDiff
} from "src/app/shared/filter";

@Component({
    selector: "report-car-temper-detail"
    ,templateUrl: './dtg.report.car.temper.detail.component.html'
    ,providers: [FilterDist,FilterSecToTime,FilterDateTime,FilterDateDiff]
})
export class DtgReportCarTemperDetailComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    userGroupId:number;
    listItem:any[] = [];
    pagingInfo:PagingInfo = new PagingInfo();
    excelPagingInfo:PagingInfo = new PagingInfo();
    dtgUnitId:string = "";
    selectedYear:number;
    selectedMonth:number;
    selectedDay:number;
    listFilterMin:number[] = [1,3,5,10,15,20,25,30];
    listHour:number[] = [];
    listMinute:number[] = [];
    selectedFilterMin:number = 30;
    selectedHourFrom:number = 0;
    selectedMinuteFrom:number = 0;
    selectedHourTo:number = 23;
    selectedMinuteTo:number = 59;
    dtgCarNo:string = "";
    @ViewChild('tblTemper', { static: false }) tblTemper: ElementRef;

    constructor(
        private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private activatedRoute: ActivatedRoute
        ,private router: Router
        ,private fvmsApiDtgReportCarService:FvmsApiDtgReportCarService
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private filterSecToTime:FilterSecToTime
        ,private filterDist:FilterDist
        ,private filterDateTime:FilterDateTime
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.pagingInfo.pageSize = 31;
        this.excelPagingInfo.pageSize = 60*60*24;

        this.dtgUnitId = this.activatedRoute.snapshot.params.dtgUnitId;
        this.selectedYear = this.activatedRoute.snapshot.params.searchYy * 1;
        this.selectedMonth = this.activatedRoute.snapshot.params.searchMm * 1;
        this.selectedDay = this.activatedRoute.snapshot.params.searchDd * 1;

        this.listHour = [];
        for(let a=0;a<24;a++){
            this.listHour.push(a);
        }
        this.listMinute = [];
        for(let a=0;a<60;a = a + 10){
            this.listMinute.push(a);
        }

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo && this.companyInfo){
                    if(this.companyInfo.companyId !== companyInfo.companyId){
                        //회사가 바뀌면 차량 목록이 다르므로 메인 페이지로 이동해야 함
                        let tmpParam = {
                            runtime:new Date().getTime()
                        };
                        let navigationExtras:NavigationExtras = {
                            queryParams:tmpParam
                        };
                        this.router.navigate(["/dtg/report/car/temper/main"],navigationExtras);
                    }
                }else{
                    this.companyInfo = companyInfo;
                }
            });
     }

    ngOnInit() {
        this.getCarInfo();
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {

    }

    getCarInfo(){
        let searchInfo = {
            companyId:this.companyInfo.companyId || 0
            ,dtgUnitId:this.dtgUnitId
        };
        this.fvmsApiDtgCarService.getCarDetail(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        let carInfo = apiResponse.resultValue;
                        this.dtgCarNo = carInfo.dtgCarNo;
                        let title = `${this.dtgCarNo} 의 온도기록일지 상세`;
                        let routeData = this.activatedRoute.snapshot.data;
                        routeData.title = title;
                    }
                }
            });
    }

    getSearchInfo(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,this.selectedDay,this.selectedHourFrom,this.selectedMinuteFrom,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth - 1,this.selectedDay,this.selectedHourTo,this.selectedMinuteTo,0,0);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd HH:mm:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd HH:mm:59");
        let searchInfo = {
            companyId:this.companyInfo.companyId || 0
            ,dtgUnitId:this.dtgUnitId
            ,searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
            ,eventTimeLimitSec:this.selectedFilterMin
        };
        return searchInfo;
    }

    reloadListItem(){
        this.fvmsCommonService.setIsLoading(true);
        this.pagingInfo.pageSize = 60*60*24;
        this.fvmsApiDtgReportCarService.getListReportCarDetailNoTrip(this.getSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listItem = []
                    if(apiResponse.resultValue){
                        this.listItem = apiResponse.resultValue;
                        let size = this.listItem.length;
                        for(let a=0;a<size;a++){
                            let item = this.listItem[a];
                            item.dtgTemper1 = (item.dtgTemper1 * 0.1).toFixed(1);;
                            item.dtgTemper2 = (item.dtgTemper2 * 0.1).toFixed(1);;

                        //     if(a === 0){
                        //         this.dtgCarNo = item.dtgCarNo;
                        //         let title = `${item.dtgCarNo} 의 온도기록일지 상세`;
                        //         // console.log("reloadListItem",title);
                        //         let routeData = this.activatedRoute.snapshot.data;
                        //         routeData.title = title;
                        //     }
                        }
                    }
                    this.pagingInfo = apiResponse.pagingInfo;
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    clickSearch(){
        this.reloadListItem();
    }

    changeFilterMin(e){
        if(e > 0){
            this.reloadListItem();
        }
    }

    changeSearchHourFrom(e){
        this.reloadListItem();
    }
    changeSearchMinuteFrom(e){
        this.reloadListItem();
    }

    changeSearchHourTo(e){
        this.reloadListItem();
    }
    changeSearchMinuteTo(e){
        this.reloadListItem();
    }

    callbackClickPageNumber(selectedPage:number){
        this.pagingInfo.curPage = selectedPage;
        this.clickSearch();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.clickSearch();
    }

    exportExcel(){
        if(this.listItem || this.listItem.length > 0){
            let wb = new Workbook();
            let ws:Worksheet = wb.addWorksheet("Sheet1");
            let align = {
                vertical:'middle'
                ,horizontal:'center'
            } as Alignment;
            let styleBorder = {style:'thin',color:{argb:"343a4000"}};
            let border = {
                top:styleBorder
                ,bottom:styleBorder
                ,left:styleBorder
                ,right:styleBorder
            } as Borders;
            let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,this.selectedDay,this.selectedHourFrom,this.selectedMinuteFrom,0,0);
            let dtTo = new Date(this.selectedYear,this.selectedMonth - 1,this.selectedDay,this.selectedHourTo,this.selectedMinuteTo,0,0);
            let searchDt = format(dtFrom,"yyyyMMdd");
            let searchTimeFrom = format(dtFrom,"HHmm");
            let searchTimeTo = format(dtTo,"HHmm");

            this.createExcelHeader(ws);

            let sizeList = this.listItem.length;
            this.listItem.forEach((itemVal,idxVal) => {
                let row = idxVal + 6;
                let arrVal = [
                    idxVal + 1
                    ,itemVal.dtgRegDt
                    ,itemVal.dtgTemper1
                    ,itemVal.dtgTemper2
                    ,""
                ];
                let rowObj = ws.insertRow(row,arrVal);
                rowObj.eachCell((itemCell,numCell) => {
                    itemCell.alignment = align;
                    itemCell.border = border;
                    if(numCell === 3 || numCell === 4){
                        itemCell.numFmt = "0.0";
                    }
                });
            });

            let fileName = "";
            fileName += "온도기록일지";
            fileName += "-";
            fileName += this.dtgCarNo;
            fileName += "-";
            fileName += searchDt;
            fileName += "-";
            fileName += searchTimeFrom;
            fileName += "-";
            fileName += searchTimeTo;
            fileName += "-";
            fileName += `${this.selectedFilterMin}분`;
            fileName += "-";
            fileName += new Date().getTime();
            fileName += ".xlsx";

            wb.xlsx.writeBuffer().then((data) => {
                // let blob = new Blob([iconv.encode(data,"euc-kr")],{ type: "application/octet-stream;"});
                let blob = new Blob([data],{ type: "application/octet-stream;"});
                FileSaver.saveAs(blob,fileName);
            });
        }
    }

    createExcelHeader(ws:Worksheet){
        let align = {
            vertical:'middle'
            ,horizontal:'center'
        } as Alignment;
        let styleBorder = {style:'thin',color:{argb:"343a4000"}};
        let border = {
            top:styleBorder
            ,bottom:styleBorder
            ,left:styleBorder
            ,right:styleBorder
        } as Borders;
        let styleBg:Fill = {
            type:'pattern'
            ,pattern:'solid'
            ,fgColor:{argb:'40CCCCCC'}
            // ,bgColor:{argb:'4000FF00'}
        };
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,this.selectedDay,this.selectedHourFrom,this.selectedMinuteFrom,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth - 1,this.selectedDay,this.selectedHourTo,this.selectedMinuteTo,0,0);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd HH:mm");
        let searchDateTo = format(dtTo,"yyyy-MM-dd HH:mm");

        ws.mergeCells('A1:E1');
        let cellTitle = ws.getCell('A1');
        cellTitle.alignment = align;
        cellTitle.border = border;
        cellTitle.value = "온도기록일지";

        let cellTitleCarNo = ws.getCell('A2');
        cellTitleCarNo.alignment = align;
        cellTitleCarNo.fill = styleBg;
        cellTitleCarNo.border = border;
        cellTitleCarNo.value = "차량번호";

        ws.mergeCells('B2:C2');
        let cellValCarNo = ws.getCell('B2');
        cellValCarNo.alignment = align;
        cellValCarNo.border = border;
        cellValCarNo.value = this.dtgCarNo;

        let cellTitleLimitMin = ws.getCell('D2');
        cellTitleLimitMin.alignment = align;
        cellTitleLimitMin.fill = styleBg;
        cellTitleLimitMin.border = border;
        cellTitleLimitMin.value = "기록단위";

        let cellValLimitMin = ws.getCell('E2');
        cellValLimitMin.alignment = align;
        cellValLimitMin.border = border;
        cellValLimitMin.value = this.selectedFilterMin + "분";

        let cellTitleSearchDate = ws.getCell('A3');
        cellTitleSearchDate.alignment = align;
        cellTitleSearchDate.fill = styleBg;
        cellTitleSearchDate.border = border;
        cellTitleSearchDate.value = "기록기간";

        ws.mergeCells('B3:E3');
        let cellValSearchDate = ws.getCell('B3');
        cellValSearchDate.alignment = align;
        cellValSearchDate.border = border;
        cellValSearchDate.value = searchDateFrom;
        cellValSearchDate.value += " ~ ";
        cellValSearchDate.value += searchDateTo;

        let cellHead1 = ws.getCell('A5');
        cellHead1.alignment = align;
        cellHead1.fill = styleBg;
        cellHead1.border = border;
        cellHead1.value = "순번";

        let cellHead2 = ws.getCell('B5');
        cellHead2.alignment = align;
        cellHead2.fill = styleBg;
        cellHead2.border = border;
        cellHead2.value = "운행일시";

        let cellHead3 = ws.getCell('C5');
        cellHead3.alignment = align;
        cellHead3.fill = styleBg;
        cellHead3.border = border;
        cellHead3.value = "온도1(℃)";

        let cellHead4 = ws.getCell('D5');
        cellHead4.alignment = align;
        cellHead4.fill = styleBg;
        cellHead4.border = border;
        cellHead4.value = "온도2(℃)";

        let cellHead5 = ws.getCell('E5');
        cellHead5.alignment = align;
        cellHead5.fill = styleBg;
        cellHead5.border = border;
        cellHead5.value = "비고";
    }

    // exportExcel2(){
    //     if(this.listItem){
    //         let ws:xlsx.WorkSheet = xlsx.utils.table_to_sheet(this.tblTemper.nativeElement);
    //         let sizeList = this.listItem.length;
    //         this.excelCellFormat(ws,6,sizeList + 6,3,4,"0.0");
    //         let wb:xlsx.WorkBook = xlsx.utils.book_new();
    //         xlsx.utils.book_append_sheet(wb,ws,'Sheet1');
    //         let searchInfo = this.getSearchInfo();
    //         let fileName = "";
    //         fileName += "온도기록일지";
    //         fileName += "-";
    //         fileName += this.dtgCarNo;
    //         fileName += "-";
    //         fileName += searchInfo.searchDateFrom.replace(/[\s:]/g,'-');
    //         fileName += "-";
    //         fileName += searchInfo.searchDateTo.replace(/[\s:]/g,'-');
    //         fileName += "-";
    //         fileName += searchInfo.eventTimeLimitSec;
    //         fileName += "-";
    //         fileName += new Date().getTime();
    //         fileName += ".xlsx";
    //         xlsx.writeFile(wb,fileName);
    //     }
    // }

    // excelCellFormat(ws:xlsx.WorkSheet,rowFrom:number = 1,rowTo:number = 1,colFrom:number = 1,colTo:number = 1,cellFromat:string){
    //     for(let row=rowFrom;row<rowTo;row++){
    //         for(let col=colFrom;col<colTo;col++){
    //             let cell = ws[xlsx.utils.encode_cell({r:row,c:col})];
    //             cell.z = cellFromat;
    //         }
    //     }
    // }
}
